import React, { useCallback, useEffect, useLayoutEffect, useMemo } from 'react';
import { Keyboard } from 'react-native';
import { AppView } from 'design-system';
import Amount from 'design-system/Amount';
import StatusBar from 'design-system/StatusBar';
import { hitSlop } from 'design-system/values';
import { ContactsList } from 'features/contacts/ContactsList';
import { muteErrorAndResult, useFetchOld } from 'hooks';
import useColors from 'hooks/useColors';
import { selectFeatureFlag } from 'reducers/selectors';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import TouchableBounce from 'utils/packages/TouchableBounce';
import Links from '../../../utils/links';
import { getActiveReferralProgram, getCreditReferrals, getReferrals, } from '../actions';
import InviteIntroView from '../components/InviteIntroView';
import InviteLink from '../components/InviteLink';
import useInviteFriends from '../hooks/useInviteFriends';
export const InviteAndGetBonusScreen = ({ navigation, }) => {
    const colors = useColors();
    const [, , isFetching, fetch] = useFetchOld(muteErrorAndResult);
    const referrals = useAppSelector((store) => store.referrals.referrals);
    const activeProgram = useAppSelector((store) => store.referrals.activeProgram);
    const isActiveProgram = activeProgram && Object.keys(activeProgram).length;
    const userUrl = useAppSelector((store) => store.user.user.userUrl);
    useLayoutEffect(() => {
        navigation.setOptions({
            headerTintColor: colors.text.primary,
        });
    }, [colors.text.primary]);
    const newReferrals = useAppSelector((store) => selectFeatureFlag(store, 'new_referrals')).value;
    const creditBasedReferrals = newReferrals &&
        activeProgram?.getPremiumCredit &&
        activeProgram?.givePremiumTrialDays;
    const dispatch = useAppDispatch();
    useEffect(() => {
        if (!isActiveProgram) {
            dispatch(getActiveReferralProgram());
        }
        fetch(creditBasedReferrals ? getCreditReferrals() : getReferrals());
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [creditBasedReferrals]);
    const handleOpenTerms = useCallback(() => {
        const termsUrl = activeProgram?.termsUrl;
        Links.openLink(termsUrl ??
            'https://help.emma-app.com/en/article/referral-program-terms-and-conditions-9whdkj/');
    }, [activeProgram?.termsUrl]);
    const handleNavToPayout = useCallback(() => {
        Keyboard.dismiss();
        navigation.navigateDeprecated('ReferralPayout', {
            creditReferrals: !!creditBasedReferrals,
        });
    }, [creditBasedReferrals]);
    const rightContent = useMemo(() => isActiveProgram ? (<TouchableBounce hitSlop={hitSlop} onPress={handleNavToPayout}>
          <Amount color={colors.text.primary} Numbers-16 value={{
            value: referrals?.cashableAmount ?? 0,
            currency: activeProgram.currency,
        }}/>
        </TouchableBounce>) : undefined, [
        activeProgram,
        colors.text.primary,
        handleNavToPayout,
        isActiveProgram,
        referrals?.cashableAmount,
    ]);
    const onPressInviteForCredit = useInviteFriends();
    if (creditBasedReferrals &&
        activeProgram.getPremiumCredit &&
        activeProgram.givePremiumTrialDays) {
        return (<AppView type="secondary" withFrame={false}>
        <StatusBar barStyle="dark-content" animated/>
        <InviteIntroView getPremiumCredit={activeProgram.getPremiumCredit} givePremiumTrialDays={activeProgram.givePremiumTrialDays} currency={activeProgram.currency} onOpenTerms={handleOpenTerms} onPressInvite={onPressInviteForCredit} onPressTrack={handleNavToPayout}/>
      </AppView>);
    }
    return (<AppView type="secondary" withFrame={false}>
      <StatusBar barStyle="dark-content" animated/>
      <ContactsList isFetching={isFetching} rightContent={rightContent} headerTitle={isActiveProgram ? 'Invite & Earn' : 'Invite'}/>
      <InviteLink link={userUrl} onOpenTerms={handleOpenTerms} text={activeProgram?.sentence} isActiveProgram={!!activeProgram} screen="first"/>
    </AppView>);
};
